var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VToggleButton',_vm._g(_vm._b({attrs:{"width":40,"height":24,"speed":150,"sync":""}},'VToggleButton',Object.assign({}, _vm.additionalProps, _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }